/**
 * Payment-related enums and constants for booking deposits
 */

export enum ViewDepositTypeEnum {
  RequestAuth = "request_auth",
  ManualAuth = "manual_auth",
  RequestPayment = "request_payment",
  ManualPayment = "manual_payment",
  CustomerPreorder = "customer_preorder"
}

export enum PaymentType {
  RequestAuth = "request_auth",
  ManualAuth = "manual_auth",
  RequestPayment = "request_payment",
  ManualPayment = "manual_payment",
  CustomerPreorder = "customer_preorder",
  CardAuthorised = "card_authorised",
  Paid = "paid"
}

export const PAYMENT_TYPE_OPTIONS = [
  { value: ViewDepositTypeEnum.RequestAuth, text: "Request Authorisation" },
  { value: ViewDepositTypeEnum.ManualAuth, text: "Manual Auth" },
  { value: ViewDepositTypeEnum.RequestPayment, text: "Request Payment" },
  { value: ViewDepositTypeEnum.ManualPayment, text: "Manual Payment" },
  { value: "paid", text: "Other Payment" }
];

export const OTHER_PAYMENT_TYPES = [
  { value: "BACS", text: "BACS" },
  { value: "Card", text: "Card" },
  { value: "Cash", text: "Cash" },
  { value: "Cheque", text: "Cheque" },
  { value: "Other", text: "Other" }
];

export const PAYMENT_TYPE_DISPLAY_NAMES: Record<string, string> = {
  request_auth: "Authenticate",
  card_authorised: "Authenticate",
  manual_auth: "Manual authenticate",
  request_payment: "Payment request",
  manual_payment: "Manual payment",
  customer_preorder: "Customer pre-order",
  paid: "Paid"
};

export const PAYMENT_TYPE_DROPDOWN_LABELS: Record<string, string> = {
  request_auth: "Request Authorisation",
  manual_auth: "Manual Auth",
  request_payment: "Request Payment",
  manual_payment: "Manual Payment",
  paid: "Other Payment"
};

export const getPaymentTypeDisplayName = (paymentType: string): string => {
  return PAYMENT_TYPE_DISPLAY_NAMES[paymentType] || paymentType;
};

export const getPaymentTypeDropdownLabel = (paymentType: string): string => {
  return PAYMENT_TYPE_DROPDOWN_LABELS[paymentType] || paymentType;
};
